import { render } from "./baseLayout.vue?vue&type=template&id=d65e99f4&scoped=true&ts=true"
import script from "./baseLayout.vue?vue&type=script&lang=ts"
export * from "./baseLayout.vue?vue&type=script&lang=ts"

import "./baseLayout.vue?vue&type=style&index=0&id=d65e99f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d65e99f4"]])

export default __exports__